import { createContext, useContext } from 'react';

const ReportContext = createContext<{
    from_datetime?: string;
    to_datetime?: string;
}>({
    from_datetime: undefined,
    to_datetime: undefined
});

export const ReportProvider = ReportContext.Provider;

export const useReportContext = () => {
    const context = useContext(ReportContext);
    return context;
};
